var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"voice-panel__wrapper"},[_c('section',{staticClass:"segment"}),_c('section',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('section',{staticClass:"operate"},[_vm._t("operate")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }